module.exports = __webpack_public_path__ + "img/horizontal_4_1_8011.5c392d1a.png";